export default __webpack_public_path__ + "static/media/a019-3.fca12a90.svg";